import { inject } from "@angular/core";
import { ActivatedRoute, CanDeactivateFn } from "@angular/router";
import { AlertService } from "@malirang/front-share";
import PreDocumentForm from "./pre-document-form";

const handleAlert = (): Promise<Boolean> => {
    return new Promise((resolve, reject) => {
        const alertService = inject(AlertService);

        alertService
            .open({
                title: "저장되지 않은 변경사항",
                content: `저장하지 않은 변경사항이 있습니다.
        작성중인 문서를 저장하시겠습니까?`,
                type: "info",
                buttons: {
                    confirm: {
                        text: "저장",
                    },
                },
            })
            .closed.subscribe({
                next: (res) => {
                    resolve(res?.action === "confirm");
                },
            });
    });
};

/**
 * 변경사항을 저장하지 않았을 경우 저장 여부를 묻는 가드
 * @param component
 * @returns
 */
export const preDocumentFormGuard: CanDeactivateFn<PreDocumentForm> = async (
    component: PreDocumentForm,
) => {
    if (component?.isDirty() && !component?.complete()) {
        const res = await handleAlert();

        if (res) {
            // skipNavigation=true로 호출하여 저장 완료 후 guard가 네비게이션 처리
            await component.handleSubmit(true);
        }
    }

    return true;
};
